import { render, staticRenderFns } from "./Diagnose.vue?vue&type=template&id=4bda7ae3&scoped=true"
import script from "./Diagnose.vue?vue&type=script&lang=js"
export * from "./Diagnose.vue?vue&type=script&lang=js"
import style0 from "./Diagnose.vue?vue&type=style&index=0&id=4bda7ae3&prod&scoped=true&lang=css"
import style1 from "./Diagnose.vue?vue&type=style&index=1&id=4bda7ae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda7ae3",
  null
  
)

export default component.exports